// Lazy-Loading der "schweren" Match-Detail-Daten (Aufstellung/Events/Statistik) - werden NICHT
// mehr mit dem großen Spielplan-Request mitgeladen (zu viel Datenvolumen bei vielen Spielen),
// sondern erst bei Bedarf (Öffnen des jeweiligen Tabs) für GENAU EIN Match nachgeladen.
//
// Cache verhindert doppeltes Nachladen, falls dasselbe Match mehrfach geöffnet wird (auch
// während ein Ladevorgang noch läuft - mehrere gleichzeitige Öffner bekommen dasselbe Promise).
//
// Server liefert { "match": matchClient } (HashMap) - wird hier entpackt, damit Aufrufer (z.B.
// DetailOverlay.vue) weiterhin einfach .lineups/.events/.statistics lesen können, ohne den
// "match"-Wrapper selbst kennen zu müssen.

const cache = new Map() // matchId -> Promise<{ lineups, events, statistics }>

/**
 * @param {string} apiBase
 * @param {string|number} matchId
 * @returns {Promise<{ lineups: any[], events: any[], statistics: any[] }>}
 */
export function ladeMatchDetails(apiBase, matchId) {
  if (cache.has(matchId)) return cache.get(matchId)

  const promise = fetch(`${apiBase}/widget/get-match-details?matchId=${encodeURIComponent(matchId)}`)
    .then(async res => {
      if (!res.ok) throw new Error(`HTTP ${res.status}`)
      const text = await res.text()
      if (!text) throw new Error('Leere Antwort von get-match-details')
      return JSON.parse(text)
    })
    .then(raw => {
      const w = raw.match ?? raw // HashMap-Wrapper entpacken
      w.teamSpieleHeimRoh = raw['matches-team-home'] ?? []
      w.teamSpieleAuswaertsRoh = raw['matches-team-away'] ?? []
      return w
    })
    .catch(err => {
      // Bei Fehler NICHT im Cache behalten - ein erneuter Öffnen-Versuch soll nochmal fetchen
      // dürfen, statt für immer auf dem fehlgeschlagenen Promise hängen zu bleiben.
      cache.delete(matchId)
      throw err
    })

  cache.set(matchId, promise)
  return promise
}

// Wirft den gecachten Stand für EIN Match weg - nötig für Live-Spiele, wo sich lineups/events/
// statistics laufend ändern (anders als bei abgeschlossenen Spielen, wo der einmal geladene
// Stand für immer gültig bleibt). Danach liefert der nächste ladeMatchDetails(...)-Aufruf
// garantiert einen frischen Fetch, keinen veralteten gecachten Wert.
export function invalidiereMatchDetails(matchId) {
  cache.delete(matchId)
}